import axios, { CancelToken } from 'axios';
import { LocationQuery } from 'vue-router';
import { cacheConfig, http } from '../helpers/axiosHelper';
export default class JourneyService {
   async getJourneys(
      search: string,
      sort: string,
      types: Array<string>,
      states: Array<string>,
      page: any,
      per_page: any,
      trashed: 'with' | 'only',
      validatable: 'only' | undefined
   ) {
      const response = await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey', {
         params: {
            include: 'customer.media,finished_submissionsCount,languages,journey_state,texts,teams.tenant',
            'filter[search]': search,
            'filter[journeyType.key]': types.join(),
            'filter[journeyState.key]': states.join(),
            'filter[trashed]': trashed,
            'filter[validatable]': validatable,
            sort: `-${sort}`,
            page,
            per_page,
         },
      });
      return response.data;
   }

   async getJourney(id: number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + id, {
            params: {
               include:
                  'customer.media,finished_submissionsCount,languages,journey_state,texts,steps.modules.module_type,steps.modules.choices,steps.modules.texts,teams.tenant,referrals.team.tenant,referrals.referral_type,texts,steps.texts,steps.modules.property.texts,steps.modules.media,steps.modules.moduleAttributes.attributable,steps.step_template.slaves,steps.modules.sort_choices_by',
               append: 'scopes,permissions,tags',
            },
         })
         .then((response) => {
            return response.data;
         });
   }

   async createJourney(body: Object) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey', body, { params: { include: 'languages' } })
         .then((response) => {
            return response.data;
         });
   }

   async patchJourney(id: Number, body: Object) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + id, body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon instelling niet wijzigen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon instelling niet wijzigen`);
         });
   }

   async putJourney(id: Number, body: Object) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + id, body).then((response) => {
         return response.data;
      });
   }

   async requestJourneyApproval(id: Number) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + id + '/request-approval').then((response) => {
         return response.data;
      });
   }

   async approveJourney(id: Number) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + id + '/approve').then((response) => {
         return response.data;
      });
   }

   async rejectJourney(id: Number, feedback: String) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + id + '/reject', { feedback_comments: feedback })
         .then((response) => {
            return response.data;
         });
   }

   async cancelJourneyReview(id: Number) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + id + '/cancel-review').then((response) => {
         return response.data;
      });
   }

   async setJourneyDraft(id: Number) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + id + '/set-draft').then((response) => {
         return response.data;
      });
   }

   async changeSettings(journeyStep: String, id: number, journeySettings: any) {
      let setting = null;
      let text = null;
      let textPatchCalls: any = [];
      let textPostCalls: any = [];
      let journeyStepCalls: any = [];

      journeySettings.forEach((journeySetting: any) => {
         if (typeof journeySetting.value === 'object' && journeySetting.textId) {
            text = [
               {
                  id: journeySetting.textId,
                  op: 'replace',
                  path: 'content',
                  value: journeySetting.value,
               },
            ];
            textPatchCalls.push(text);
         } else if (typeof journeySetting.value === 'object' && journeySetting.path != 'name') {
            text = {
               id: null,
               textable_id: id,
               textable_type: journeyStep.charAt(0).toUpperCase() + journeyStep.slice(1),
               type: journeySetting.path,
               content: journeySetting.value,
            };

            textPostCalls.push(text);
         } else {
            setting = {
               op: 'replace',
               path: journeySetting.path,
               value: journeySetting.value,
            };
            journeyStepCalls.push(setting);
         }
      });

      var allCalls: any = [];
      if (textPatchCalls.length > 0) {
         textPatchCalls.forEach((textPatchCall: any) => {
            const textId = textPatchCall[0].id;
            delete textPatchCall[0].id;
            allCalls.push(
               http.patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/text/` + textId, textPatchCall).then((response) => {
                  return response;
               })
            );
         });
      }

      if (textPostCalls.length > 0) {
         textPostCalls.forEach((textPostCall: any) => {
            allCalls.push(
               http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/text`, textPostCall).then((response) => {
                  return response;
               })
            );
         });
      }

      if (journeyStepCalls.length > 0) {
         allCalls.push(
            http.patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/${journeyStep}/` + id, journeyStepCalls).then((response) => {
               return response;
            })
         );
      }

      return await axios.all(allCalls).then((response) => {
         return response;
      });
   }
   async postJourneyLanguage(body: any) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-language', body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon taal niet toevoegen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon taal niet toevoegen`);
         });
   }
   async deleteJourneyLanguage(id: Number) {
      return await http
         .delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-language/' + id)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Kon taal niet verwijderen`);
            }
         })
         .catch((error) => {
            throw Error(`Kon taal niet verwijderen`);
         });
   }
   async getExport(journeyId: Number, language: String) {
      const response = await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + journeyId + '/download-result', {
         params: { language: language },
      });
      return response;
   }

   async getStatusExport(id: Number, startDate: any, endDate: any) {
      return await http
         .get(
            import.meta.env.VITE_APP_API_BASE_URL_DATA +
               '/dashboard/journey/' +
               id +
               '/influxPerSubmissionState' +
               '/download' +
               '?start=' +
               startDate +
               '&end=' +
               endDate
         )
         .then((response) => {
            return response;
         });
   }

   async getReferralSubmissionStateExport(journeyId: Number) {
      return await http
         .get(
            import.meta.env.VITE_APP_API_BASE_URL_DATA + '/dashboard/journey/' + journeyId + '/influxPerReferralPerSubmissionState/download'
         )
         .then((response) => {
            return response;
         });
   }

   async showResult(journeyId: Number) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + journeyId + '/show-result').then((response) => {
         return response.data;
      });
   }

   async deleteJourney(journeyId: Number) {
      return await http
         .delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + journeyId)
         .then((response) => {
            return response;
         })
         .catch((error) => {
            error.response;
            return error.response;
         });
   }

   async restoreJourney(journeyId: Number) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + journeyId + '/restore').then((response) => {
         return response;
      });
   }

   async duplicateJourney(journeyId: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + journeyId + '/duplicate')
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error('Kon journey niet dupliceren');
            }
         })
         .catch((error) => {
            throw error;
         });
   }

   async getJourneyAnomalies(journeyId: Number, cancelToken: CancelToken) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + journeyId + '/anomalies', { cancelToken: cancelToken })
         .then((response) => {
            return response.data;
         });
   }

   async getNotificationTypes() {
      return http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/notification', { ...cacheConfig }).then((response) => {
         return response.data;
      });
   }

   async getJourneyHistory(journeyId: number, query: LocationQuery) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey/' + journeyId + '/history', { params: query })
         .then((response) => {
            return response.data;
         });
   }
}
